import { render } from "./Participantes.vue?vue&type=template&id=12f01280&scoped=true"
import script from "./Participantes.vue?vue&type=script&lang=js"
export * from "./Participantes.vue?vue&type=script&lang=js"

import "./Participantes.vue?vue&type=style&index=0&id=12f01280&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f01280"]])

export default __exports__